import { Map } from "immutable";

export const GssCountries = Map<number, string>([[103, "India"]]);
export const GssRegionIds = Map<number, string>([[841, "India"]]);
